<template>
    <div class="row">
        <div id="transition-container">
            <paginate v-if="hasPosts"
                      name="posts"
                      :list="posts"
                      :per="perPage"
                      tag="div">
                <div class="col-md-12">
                    <agenda-entry v-for="post in paginated('posts')"
                                  :post="post"
                                  :key="post.slug">
                    </agenda-entry>
                </div>
            </paginate>
        </div>

        <div class="col-md-12">
            <p v-if="! hasPosts && ! isLoading">Aucun article trouvé...</p>
        </div>

        <div v-if="showPagination"
             class="pagination-container"
             id="pagination-container">
            <paginate-links
                for="posts"
                :limit="2"
                @change="scrollToTopOfPosts">
            </paginate-links>
        </div>
    </div>
</template>

<script>
  import AgendaEntry from './AgendaEntry.vue'
  import VuePaginate from 'vue-paginate'

  export default {

    components: {
      AgendaEntry, VuePaginate
    },

    data () {
      return {
        posts: [],
        postType: null,
        wpTotal: 0,
        isLoading: true,
        paginate: ['posts']
      }
    },

    computed: {

      hasPosts () {
        return this.posts.length > 0
      },

      perPage () {
        return window.initialState.perPage
      },

      showPagination () {
        return this.posts.length > this.perPage
      }

    },

    methods: {

      getInitialState () {
        this.postType = window.initialState.postType
        this.posts = window.initialState.posts
        this.wpTotal = window.initialState.wpTotal
      },

      getRemainingPosts () {
        this.isLoading = true
        let offset = this.posts.length
        let url = apiUrl + 'oip/v1/' + this.postType + 's/'
        let params =  {
          _embed: 'featuredmedia',
          offset: offset,
          per_page: this.perPage
        }
        this.$http.get(url, {
          params: params
        }).then(response => {
          this.wpTotal = parseInt(response.headers.get('X-Wp-Total'))
          _.forEach(response.body, item => {
            this.posts.push(item)
          })
          if (this.posts.length < this.wpTotal) {
            this.isLoading = true
            this.getRemainingPosts()
          } else {
            this.isLoading = false
          }
        }).catch(response => {
          this.isLoading = false
        })
      },

      scrollToTopOfPosts () {
        document.getElementById('transition-container').classList.add('loading')
        //this.isLoading = true
        setTimeout(() => {
          document.getElementById('top-for-scroll').scrollIntoView({
            behavior: 'smooth'
          });
          document.getElementById('transition-container').classList.remove('loading')
          //this.isLoading = false
        }, 200)

        //document.getElementById('top-for-scroll').scrollIntoView({
        //  behavior: 'smooth'
        //})
      }

    },

    watch: {

      isLoading (value) {
        if (value === true) {
          document.getElementById('app-container').classList.add('loading')
        } else {
          document.getElementById('app-container').classList.remove('loading')
        }
      },

    },

    mounted () {
      this.getInitialState()
      this.getRemainingPosts()
    }

  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/agenda/AgendaList.vue